import React from 'react';
import './App.css';
import Cube from './Cube';

function App() {
  return (
      <div className="App">
        <Cube />
      </div>
  );
}

export default App;
